import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './containers/HomePage';
import Location from './containers/Location';
import ItemPage from './containers/itemPage';
import Category from './containers/Category';
import SearchPage from './containers/SearchPage';
import { initGA } from './utils/analytics';
import LoadingSpinner from './components/LoadingSpinner';

const AppWrapper = styled.div`
  max-width: 100vw;
  overflow-x: hidden;

  .pagecontent {
    transition: margin-top 0.3s;
    margin: 0 auto;
    max-width: 470px;
    width: 100%;
  }

  @media (max-width: 470px) {
    .pagecontent {
      max-width: 100%;
    }
  }

  @media (min-width: 769px) {
    .pagecontent {
      padding-left: 15px;
      padding-right: 15px;
    }
  }
`;

// Create a separate component for the app content
const AppContent = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    initGA();
    const timer = setTimeout(() => setIsLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <AppWrapper className={menuOpen ? 'menu-open' : ''}>
      <Header menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <div className="pagecontent">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/location/:location" element={<Location />} />
          <Route path="/location/:location/:category" element={<Category />} />
          <Route path="/items/:id" element={<ItemPage />} />
          <Route path="/location/:location/search" element={<SearchPage />} />
        </Routes>
      </div>
      <Footer />
    </AppWrapper>
  );
};

function App() {
  return (
    <Provider store={store}>
      <Router>
        <AppContent />
      </Router>
    </Provider>
  );
}

export default App;
